<template>
  <div class="l-container-inner">
    <Banner></Banner>
  </div>
</template>

<script>
import Banner from '@/components/Banner'

export default {
  name: 'Home',
  components: {
    Banner
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue